import "./experience-block.scss";
import { Tag } from "../molecules";

const ExperienceBlock = (props: any) => {
  const { experience } = props;

  return (
    <div className="block-container">
      <div className="header">
        <div className="dot"></div>
        <div className="duration">
          {" "}
          {experience?.duration?.from} - {experience?.duration?.to}{" "}
        </div>
      </div>
      <div className="footer">
        <div className="footer__top">
          <span className="designation">{experience?.designation} </span> at{" "}
          <a className="company" href={experience?.company?.url}>
            {experience?.company?.name}
          </a>
        </div>
        <div className="footer__mid">
          {experience?.technologies?.map(
            (technology: string, index: number) => (
              <Tag title={technology} key={index} />
            )
          )}
        </div>
        <div className="footer__bottom">
          <p className="footer__bottom-title">Key responsibilities:</p>
          <ul className="responsibilities">
            {experience?.responsibilities?.map(
              (responsibility: string, index: number) => (
                <li>{responsibility}</li>
              )
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ExperienceBlock;
